import { Suspense } from 'react';

import { StyleSheetManager } from 'styled-components';

import {
  ApplicationProcessPageLayout,
  CenteredLoadingIndicator,
  ErrorBoundary,
} from '@storebrand-digital/bank-foundation-components';
import {
  SpacingStyleSheet,
  FlexStyleSheet,
} from '@storebrand-digital/bank-foundation-helper-styles';
import { getText } from '@storebrand-digital/fms-translations';

import { ApiProvider } from '@api/context/ApiContext';
import { isWebView } from '@app/utils';
import { SDCAndroidBugSpacer } from '@components/SDCAndroidBugSpacer';

import InitProvider from '../components/InitProvider';
import PageWidth from '../components/PageWidth';
import ErrorPageView from '../features/ErrorPageView';
import Router from '../router';

export default function App() {
  return (
    <StyleSheetManager shouldForwardProp={() => true}>
      <SpacingStyleSheet />
      <FlexStyleSheet />
      <InitProvider>
        <ApiProvider>
          <ErrorBoundary errorView={ErrorPageView}>
            <Suspense fallback={<CenteredLoadingIndicator isFixed />}>
              <ApplicationProcessPageLayout
                body={
                  <div>
                    <PageWidth className="mb-24">
                      <Router />
                    </PageWidth>
                    {isWebView && <SDCAndroidBugSpacer />}
                  </div>
                }
                footer={
                  <PageWidth
                    id="app-footer"
                    aria-label={getText(
                      'bankForChildren.orderAccount.form.buttonGroup.ariaLabel'
                    )}
                    className="flex justify-between [&:has(>*:only-child)]:justify-end"
                  />
                }
              />
            </Suspense>
          </ErrorBoundary>
        </ApiProvider>
      </InitProvider>
    </StyleSheetManager>
  );
}
